import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Polyv2API {
	/**
	 * @path /pages/:pgid/poly
	 * @param pgid - Page ID
	 * @param token - Token
	 * @param query - Query parameters (take, skip, job_id, uid)
	 */
	async getAllUsersPoly(pgid: string, token: string, query?: { take?: number; skip?: number; job_id?: string; uid?: string }) {
		return xget<{
			results: PGSchema.users_poly[];
			positions: PGSchema.jobs[];
			users: PGSchema.users[];
		}>(`/pages/${pgid}/poly`, query || {}, {
			headers: { "app-token": token }
		});
	}

	async getPoly(pgid: string, polyId: string) {
		return xget<{ poly: PGSchema.users_poly; position: PGSchema.jobs; user: PGSchema.users }>(`/pages/${pgid}/poly/${polyId}`, {}, { headers: {} });
	}

	/**
	 * @path /pages/:pgid/poly
	 * @param pgid - Page ID
	 * @param data - Users Poly data (must include pgid and job_id)
	 * @param token - Token
	 */
	async createUsersPoly(pgid: string, data: Partial<PGSchema.users_poly>, token: string) {
		return xhttp<{
			poly: PGSchema.users_poly;
			user: PGSchema.users;
			position: PGSchema.jobs;
		}>(`/pages/${pgid}/poly`, "POST", data, {
			headers: { "app-token": token }
		});
	}

	/**
	 * @path /pages/:pgid/poly/:poly_id/link
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param polyId - Poly ID
	 * @param url - URL to link
	 */
	async updatePolyLink(pgid: string, polyId: string, url: string) {
		return xhttp<PGSchema.users_poly>(`/pages/${pgid}/poly/${polyId}/link`, "POST", { url }, {});
	}

	/**
	 * @path /pages/:pgid/poly/:tid
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param tid - Poly ID to delete
	 * @param token - Token
	 */
	async deleteUsersPoly(pgid: string, tid: string, token: string) {
		return xhttp<{ ok: boolean; message: string }>(
			`/pages/${pgid}/poly/${tid}`,
			"DELETE",
			{},
			{
				headers: { "app-token": token }
			}
		);
	}
}
